import { fetcher } from "helpers/fetcher";

import { TGetJobListingBrochureReq, TGetJobListingBrochureRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getJobListingBrochure = async (
  params: TGetJobListingBrochureReq
) => {
  return await fetcher<
    TGetJobListingBrochureRes,
    TGetJobListingBrochureReq["data"]
  >(ENDPOINT.CORPORATION.GET_JOB_LISTING_BROCHURE, {
    params: params?.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.GET_JOB_LISTING_BROCHURE.version,
      [API_HEADER.CORP_ID]: params?.idCorp,
    },
  });
};

export const queryGetJobListingBrochure = async (
  params: TGetJobListingBrochureReq
) => {
  return (await getJobListingBrochure(params)).data;
};

queryGetJobListingBrochure._key = (
  params: TGetJobListingBrochureReq,
  key?: string
) => [ENDPOINT.CORPORATION.GET_JOB_LISTING_BROCHURE.url, params, key];
